export default {
  chooseLanguage: 'Selecciona el idioma en el que crearás tu recurso',
  addLanguage: 'Agregar idioma',
  cancel: 'Cancelar'
}

export const en = {
  chooseLanguage: 'Select the language in which you will create your resource',
  addLanguage: 'Add language',
  cancel: 'Cancel'
}

export const ca = {
  chooseLanguage: 'Selecciona l\'idioma en el que crearàs el teu recurs',
  addLanguage: 'Afegir idioma',
  cancel: 'Cancelar'
}
